<template>
  <div v-if="isLoaded">
    <van-row style="margin-top: 10px;">
      <van-col span="10" style="text-align: center;">
        <img :src="proxy + base64(vod.vod_pic)" style="max-height: 200px; max-width: 140px; margin-left: 10px; margin-right: 10px;"/>
      </van-col>
      <van-col span="14">
        <p>{{ vod.vod_year }} / {{ vod.vod_area }}</p>
        <p class="content-more">{{ vod.vod_actor }}</p>
        <p>{{ vod.type_name.replaceAll(',', ' / ') }}</p>
        <span v-if="vod.vod_content">内容简介:</span>
        <p v-html="vod.vod_content" class="content" v-if="vod.vod_content.length > 100 && !isMore"></p>
        <p v-html="vod.vod_content" class="content-more" v-else></p>
        <van-button size="small" style="float: right; margin-right: 30px;" v-if="vod.vod_content.length > 100 && !isMore" @click="isMore = true">更多</van-button>
        <van-button size="small" style="float: right; margin-right: 30px;" v-else @click="isMore = false">收回</van-button>
      </van-col>
    </van-row>
    <van-tabs v-if="vod.vod_play_urls.length > 1">
      <van-tab v-for="(series, index) in vod.vod_play_urls" :title="'线路' + (index + 1)" :key="'node_' + index">
        <div class="playlist">
          <span v-for="item in series" @click="play(item)" :key="item.play_url">
            <van-button style="margin: 10px 10px 0px;" class="video-actived" v-if="isPlayed(item)">{{ item.name }}</van-button>
            <van-button style="margin: 10px 10px 0px;" v-else>{{ item.name }}</van-button>
          </span>
        </div>
      </van-tab>
    </van-tabs>
    <div class="playlist" v-else>
      <span v-for="item in vod.vod_play_urls[0]" @click="play(item)" :key="item.play_url">
        <van-button style="margin: 10px 10px 0px;" class="video-actived" v-if="isPlayed(item)">{{ item.name }}</van-button>
        <van-button style="margin: 10px 10px 0px;" v-else>{{ item.name }}</van-button>
      </span>
    </div>
  </div>
</template>

<script>
import { Vod } from '@/api/model'
import { getVodDetail, getVodPlayUrl } from '@/api/vod'
import { Base64 } from 'js-base64'

export default {
  name: 'VodDetail',
  data () {
    return {
      proxy: 'http://cloud.ai-ifast.com/mesh/cloud/vod/proxy?url=',
      sourceKey: '',
      id: '',
      vod: Vod(),
      isMore: false,
      isLoaded: false,
      playHistory: ''
    }
  },
  methods: {
    base64 (str) {
      return Base64.encode(str)
    },
    getVodDetail () {
      if (!this.$parent.isVip()) {
        return false
      }
      this.$parent.progressOn()
      getVodDetail({
        sourceKey: this.sourceKey,
        id: this.id
      }).then(res => {
        this.vod = res.result
        this.$parent.title = this.vod.vod_name
        this.$parent.progressOff()
        this.isLoaded = true
      })
    },
    play (video) {
      if (!this.$parent.isVip()) {
        return false
      }
      console.log(video.play_url)
      this.setPlayed(video)
      if (video.play_url.indexOf('http') === -1) {
        if (!['2720681a1622b946', '2720681a0029ae468d'].includes(this.sourceKey)) {
          this.$message.info('服务器连接异常请切换视频源')
          return false
        }
        this.$parent.progressOn()
        getVodPlayUrl({
          sourceKey: this.sourceKey,
          playUrl: video.play_url
        }).then(res => {
          console.log(res.result.url)
          this.$parent.progressOff()
          this.playUrl(this.vod.vod_name + ' ' + video.name + '::::' + res.result.url)
        })
      } else {
        this.playUrl(this.vod.vod_name + ' ' + video.name + '::::' + video.play_url)
      }
    },
    playUrl (content) {
      if (typeof window.webkit === 'undefined') {
        window.open(content.split('::::')[1])
        return
      }
      window.webkit.messageHandlers.play.postMessage(content)
    },
    setPlayed (video) {
      this.playHistory = JSON.parse(window.localStorage.getItem('vod_played_list')) || {}
      if (typeof this.playHistory[this.sourceKey] === 'undefined') {
        this.playHistory[this.sourceKey] = {}
      }
      this.playHistory[this.sourceKey][this.id] = video.name
      window.localStorage.setItem('vod_played_list', JSON.stringify(this.playHistory))
    },
    isPlayed (video) {
      if (this.playHistory === '') {
        this.playHistory = JSON.parse(window.localStorage.getItem('vod_played_list')) || {}
      }
      if (typeof this.playHistory[this.sourceKey] === 'undefined') {
        return false
      }
      if (typeof this.playHistory[this.sourceKey][this.id] === 'undefined') {
        return false
      }
      if (this.playHistory[this.sourceKey][this.id] === video.name) {
        return true
      }
    },
    change () {
      this.$parent.navLeftText = ''
      this.sourceKey = this.$route.params.skey
      this.id = this.$route.params.vid
      this.getVodDetail()
    }
  },
  mounted () {
    this.change()
  }
}
</script>

<style lang="less">
.playlist {
  height: calc(100% - 200px);
  overflow-y: scroll;
}

.content {
  width: 90%;
  margin-right: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.content-more {
  width: 90%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.video-actived {
  background-color: #a3a3a3;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/inApp/Vod/Detail.vue